import { render, staticRenderFns } from "./importeModal.vue?vue&type=template&id=1c0eca6f&"
import script from "./importeModal.vue?vue&type=script&lang=js&"
export * from "./importeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports